<template>
    <form @change="isFormDirty" @submit.prevent="handleSubmit" class="form-container" data-cy="form-container">
        <p class="text-center text-default-red p-2" v-if="validation.message">
            {{ validation.message }}
        </p>
        <div class="form-section">
            <div class="section-body" data-cy="section-general">
                <div
                    v-if="is_create && is_admin_section"
                    class="input-container mb-2"
                    :class="{ 'w-full px-4': form_mode == 'drawer' }"
                    data-cy="association-field"
                >
                    <ui-label>{{ $t('company.general.association') }}</ui-label>
                    <a-select
                        show-search
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        @change="handleFilterChange"
                        :allowClear="true"
                        :class="{ 'form-error': v$.$anyDirty && company.association_id == null }"
                    >
                        <a-select-option v-for="(value, index) in association_list" :key="index" :value="index">
                            {{ value.name }}
                        </a-select-option>
                    </a-select>
                    <div
                        data-cy="field-association-error"
                        :class="{ 'text-default-red': company.association_id == null }"
                        v-if="v$.$anyDirty && company.association_id == null"
                    >
                        {{ $t('validation.required') }}
                    </div>
                </div>
                <div
                    v-if="
                        !is_create ||
                        (!is_admin_section && company.association_id != '' && company.association_id != null)
                    "
                    class="input-container mb-2"
                    :class="{ 'w-full px-4': form_mode == 'drawer' }"
                    data-cy="company-settings-association"
                >
                    <ui-label>{{ $t('company.general.association') }}</ui-label>
                    <div class="subText">{{ company.association_name }}</div>
                </div>
                <div
                    v-if="is_create || (!is_create && is_admin_section)"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-name-field"
                >
                    <ui-label>{{ $t('company.general.company_name') }}</ui-label>
                    <ui-input v-model="v$.company.name.$model" :class="{ 'form-error': v$.company.name.$error }" />
                    <div
                        data-cy="field-name-error"
                        :class="{ 'text-default-red': v$.company.name.$error }"
                        v-if="v$.company.name.required.$invalid && v$.company.name.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                </div>
                <div
                    v-if="!is_create && !is_admin_section"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-2/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-name-field"
                >
                    <ui-label>{{ $t('company.general.company_name') }}</ui-label>
                    <div class="subText">{{ company.name }}</div>
                </div>
                <div
                    v-if="!is_create"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-id-field"
                >
                    <ui-label>{{ $t('company.general.company_id') }}</ui-label>
                    <div class="subText">{{ company.company_id }}</div>
                </div>
                <div
                    v-if="is_create || (!is_create && is_admin_section)"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/3': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-code-field"
                >
                    <ui-label>{{ $t('company.general.company_code') }}</ui-label>
                    <ui-input
                        v-model="v$.company.company_code.$model"
                        :class="{ 'form-error': v$.company.company_code.$error }"
                    />
                    <div
                        data-cy="field-company-code-error"
                        :class="{ 'text-default-red': v$.company.company_code.$error }"
                        v-if="v$.company.company_code.required.$invalid && v$.company.company_code.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                </div>
                <div
                    v-if="!is_create && !is_admin_section"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/3': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-code-field"
                >
                    <ui-label>{{ $t('company.general.company_code') }}</ui-label>
                    <div class="subText">{{ company.company_code }}</div>
                </div>
                <div
                    v-if="is_create || (!is_create && is_admin_section)"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-type-field"
                >
                    <ui-label>{{ $t('company.general.company_type') }}</ui-label>
                    <ui-select
                        v-model="v$.company.company_type.$model"
                        :options="company_types"
                        :class="{ 'form-error': v$.company.company_type.$error }"
                    />
                    <div
                        data-cy="field-company-type-error"
                        :class="{ 'text-default-red': v$.company.company_type.$error }"
                        v-if="v$.company.company_type.required.$invalid && v$.company.company_type.$error"
                    >
                        {{ $t('validation.required') }}
                    </div>
                </div>
                <div
                    v-if="!is_create && !is_admin_section"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-type-field"
                >
                    <ui-label>{{ $t('company.general.company_type') }}</ui-label>
                    <div class="subText">{{ captilalizeText(company.company_type) }}</div>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-national-id-field"
                >
                    <ui-label>{{ $t('company.general.national_id') }}</ui-label>
                    <ui-input v-model="v$.company.national_id.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-2/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-contact-first-name-field"
                >
                    <ui-label>{{ $t('company.general.contact_first_name') }}</ui-label>
                    <ui-input v-model="v$.company.contact_first_name.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-2/5 md:w-1/3': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-contact-last-name-field"
                >
                    <ui-label>{{ $t('company.general.contact_last_name') }}</ui-label>
                    <ui-input v-model="v$.company.contact_last_name.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-salutation-field"
                >
                    <ui-label>{{ $t('company.general.salutation') }}</ui-label>
                    <ui-select v-model="v$.company.salutation.$model" :options="salutations" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-4/5 md:w-3/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-mailing-address-field"
                >
                    <ui-label>{{ $t('company.general.mailing_address') }}</ui-label>
                    <ui-input v-model="v$.company.mailing_address.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-telephone-number-field"
                >
                    <ui-label>{{ $t('company.general.telephone_number') }}</ui-label>
                    <ui-input
                        v-model="v$.company.telephone_number.$model"
                        :class="{ 'form-error': v$.company.telephone_number.$error }"
                        :formatter="formatters.phoneFormatter"
                    />
                    <div
                        data-cy="field-company-telephone-number-error"
                        :class="{ 'text-default-red': v$.company.telephone_number.$error }"
                        v-if="v$.company.telephone_number.phone.$invalid && v$.company.telephone_number.$error"
                    >
                        {{ $t('validation.phone', { attribute: 'value entered' }) }}
                    </div>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{
                        'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init',
                        'w-1/2 px-4': form_mode == 'drawer',
                    }"
                    data-cy="company-settings-general-ip-range"
                    v-if="company.is_ip_address_routing"
                >
                    <ui-label>{{ $t('company.general.ip_range') }}</ui-label>
                    <ui-input v-model="v$.company.ip_range.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{
                        'pr-4 lg:w-2/5 md:w-2/5': form_mode == 'init',
                        'w-1/2 px-4': form_mode == 'drawer',
                    }"
                    data-cy="association-company-email-address-field"
                >
                    <span class="flex justify-between">
                        <ui-label>{{ $t('company.general.email_address') }}</ui-label>
                        <a-tooltip v-if="!is_create" placement="right" :title="$t('company.general.autofill_email')">
                            <PlusSquareOutlined
                                data-cy="drawer-update-autofill"
                                @click="autofillEmail"
                                class="hover:text-blue-400 self-center"
                                :disabled="processing"
                            />
                        </a-tooltip>
                    </span>
                    <ui-select
                        v-model="v$.company.email_address.$model"
                        :class="{ 'form-error': v$.company.email_address.$error }"
                        :mode="'tags'"
                    />
                    <div
                        class="w-full mb-2"
                        data-cy="field-email-format-error"
                        :class="{ 'text-default-red': v$.company.email_address.$error }"
                        v-if="v$.company.email_address.emailValidation.$invalid && v$.company.email_address.$error"
                    >
                        {{ $t('validation.emails', { attribute: 'value entered' }) }}
                    </div>
                </div>
                <div
                    v-if="isCiaEnabled && v$.company.company_type.$model.toLowerCase() == 'insurer'"
                    class="input-container mb-2"
                    :class="{
                        'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init',
                        'w-1/2 px-4': form_mode == 'drawer',
                    }"
                    data-cy="company-settings-general-authorized-intermediary-id"
                >
                    <ui-label>{{ $t('company.general.authorized_intermediary_id') }}</ui-label>
                    <ui-input v-model="v$.company.authorized_intermediary_id.$model" />
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-settings-general-last-imported-date"
                    v-if="company.claim_last_imported_at"
                >
                    <span class="flex justify-between">
                        <ui-label>{{ $t('company.general.claim_last_imported_at') }}</ui-label>
                        <a-tooltip placement="right" :title="$t('company.general.update')">
                            <SyncOutlined
                                data-cy="drawer-update-date"
                                @click="updateDate"
                                class="hover:text-blue-400"
                                :disabled="processing"
                            />
                        </a-tooltip>
                    </span>
                    <div class="subText">{{ company.claim_last_imported_at }}</div>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-settings-general-last-imported-date"
                    v-if="company.cover_last_imported_at"
                >
                    <span class="flex justify-between">
                        <ui-label>{{ $t('company.general.cover_last_imported_at') }}</ui-label>
                    </span>
                    <div class="subText">{{ company.cover_last_imported_at }}</div>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-settings-general-deactivation-date"
                    v-if="company.deactivation_date !== null"
                >
                    <span class="flex justify-between">
                        <ui-label>{{ $t('company.general.deactivation_date') }}</ui-label>
                        <a-tooltip placement="right" :title="$t('company.general.update_deactivation_date')">
                            <SyncOutlined
                                data-cy="drawer-update-deactivation-date"
                                @click="updateDeactivationDate"
                                class="hover:text-blue-400"
                                :disabled="processing"
                            />
                        </a-tooltip>
                    </span>
                    <div class="subText">{{ company.deactivation_date }}</div>
                </div>
                <div
                    v-if="!is_create"
                    class="input-container mb-2"
                    :class="{ 'lg:w-3/5 md:w-3/5 pr-4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="company-settings-general-active-user-count"
                >
                    <ui-label>{{ $t('company.general.active_users') }}</ui-label>
                    <div class="subText">{{ company.user_count }}</div>
                </div>
                <div class="w-full" />
                <div
                    class="input-container mb-2"
                    :class="{
                        'w-1/2 pr-4': form_mode == 'init',
                        'w-1/2 px-4': form_mode == 'drawer',
                    }"
                    data-cy="association-company-logo"
                >
                    <ui-label>
                        {{ $t('company.general.logo') }}
                        <a-tooltip placement="right" :title="$t('globals.buttons.delete')">
                            <DeleteOutlined
                                v-if="company.insurer_logo"
                                class="text-default-red"
                                @click="handleRemove"
                            />
                        </a-tooltip>
                    </ui-label>
                    <a-upload
                        class="w-3/4 avatar-uploader"
                        list-type="picture-card"
                        :show-upload-list="false"
                        :before-upload="beforeUpload"
                    >
                        <img v-if="company.insurer_logo" :src="company.insurer_logo" alt="avatar" />
                        <div v-else>
                            <LoadingOutlined v-if="loading" />
                            <PlusOutlined v-else />
                            <div class="ant-upload-text">{{ $t('company.general.upload') }}</div>
                        </div>
                    </a-upload>
                    <validation-errors :errors="validation.errors.insurer_logo" v-if="validation.errors" />
                </div>
                <div class="w-full flex" v-if="isEpicVaultEnabled">
                    <div
                        data-cy="association-company-field-settings-is-module-claimsvault-enabled"
                        class="input-container"
                        :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    >
                        <a-checkbox
                            v-model:checked="company.is_module_claimsvault_enabled"
                            @change="onClaimsVaultModuleChange"
                            :disabled="!is_admin_section || !company.is_association_module_claimsvault_enabled"
                        >
                            {{ $t('company.general.is_module_claimsvault_enabled') }}
                        </a-checkbox>
                    </div>
                    <div
                        data-cy="association-company-field-settings-is-module-covervault-enabled"
                        class="input-container"
                        :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    >
                        <a-checkbox
                            v-model:checked="company.is_module_covervault_enabled"
                            @change="onCoverVaultModuleChange"
                            :disabled="!is_admin_section || !company.is_association_module_covervault_enabled"
                        >
                            {{ $t('company.general.is_module_covervault_enabled') }}
                        </a-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="company.is_module_claimsvault_enabled"
            class="form-section"
            data-cy="section-claim-vault-modules"
            :class="{ 'mb-4': form_mode == 'drawer' }"
        >
            <div class="form-section-header" :class="{ 'pr-4': form_mode == 'init', 'px-4': form_mode == 'drawer' }">
                <div data-cy="company-claim-vault-settings">
                    {{ $t('company.general.claims_flags') }}
                </div>
            </div>
            <div class="section-body">
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-enable-advanced-claims-analytics"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.enable_advanced_claims_analytics">
                        {{ $t('company.general.enable_advanced_claims_analytics') }}
                    </ui-checkbox>
                </div>
                <div
                    class="input-container checkbox-container mb-2"
                    :class="{ 'lg:w-2/5 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <div data-cy="association-company-field-hide-claim-description">
                        <ui-checkbox v-model="company.is_hide_claim_description">
                            {{ $t('company.general.is_hide_claim_description') }}
                        </ui-checkbox>
                    </div>
                </div>
                <div
                    data-cy="association-company-field-settings-update-upload-date-on-new-claims"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.update_upload_date_on_new_claims" :disabled="!is_admin_section">
                        {{ $t('company.general.update_upload_date_on_new_claims') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-is-enforce-column-count-restriction"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_enforce_column_count_restriction" :disabled="!is_admin_section">
                        {{ $t('company.general.is_enforce_column_count_restriction') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-include-rejected-claims-report-email"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.email_rejected_records_on_upload_claims">
                        {{ $t('company.general.email_rejected_records_on_upload_claims') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="company.is_module_claimsvault_enabled"
                    data-cy="association-company-field-settings-send-import-claim-email"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.send_import_claim_email">
                        {{ $t('company.general.send_import_claim_email') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-is-claim-flat-file-accepted"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-full px-4': form_mode == 'drawer' }"
                >
                    <div>{{ $t('company.general.is_claim_file_upload_type') }}</div>
                    <ui-select
                        v-model="v$.company.claim_file_upload_type.$model"
                        :options="claims_upload_file_types"
                        :class="{ 'form-error': v$.company.claim_file_upload_type.$error }"
                    />
                </div>
            </div>
        </div>
        <div
            v-if="company.is_module_covervault_enabled"
            class="form-section"
            data-cy="section-cover-vault-settings"
            :class="{ 'mb-4': form_mode == 'drawer' }"
        >
            <div class="form-section-header" :class="{ 'pr-4': form_mode == 'init', 'px-4': form_mode == 'drawer' }">
                <div data-cy="company-cover-vault-settings">
                    {{ $t('company.general.cover_flags') }}
                </div>
            </div>
            <div class="section-body">
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-enable-advanced-covers-analytics"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.enable_advanced_cover_analytics">
                        {{ $t('company.general.enable_advanced_cover_analytics') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="company.is_module_covervault_enabled"
                    data-cy="association-company-field-settings-send-import-cover-email"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.send_import_cover_email">
                        {{ $t('company.general.send_import_cover_email') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-include-rejected-covers-report-email"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.email_rejected_records_on_upload_covers">
                        {{ $t('company.general.email_rejected_records_on_upload_covers') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="isEpicVaultEnabled"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <div data-cy="association-company-field-settings-allow-full-association-cover-search">
                        <ui-checkbox
                            v-model="company.allow_full_association_cover_search"
                            :disabled="!company.is_module_covervault_enabled"
                        >
                            {{ $t('company.general.allow_full_association_cover_search') }}
                        </ui-checkbox>
                    </div>
                </div>
                <div
                    v-if="company.is_module_covervault_enabled && company.is_association_module_covervault_enabled"
                    class="input-container mb-2"
                    :class="{
                        'w-1/2 pr-4': form_mode == 'init',
                        'w-1/2 px-4': form_mode == 'drawer',
                    }"
                    data-cy="company-settings-general-max-imediate-cover-processing-limit"
                >
                    <ui-label>{{ $t('company.general.max_immediate_cover_processing_limit') }}</ui-label>
                    <ui-input-number
                        @updatedValue="onFormChange"
                        :min="0"
                        :max="100"
                        v-model="v$.company.max_immediate_cover_processing_limit.$model"
                    />
                    <p class="text-help">
                        {{ $t('company.general.help.max_immediate_cover_processing_limit') }}
                    </p>
                </div>
                <div class="w-full" />
                <div
                    v-if="!is_create && isCiaEnabled && company.company_type.toLowerCase() == 'insurer'"
                    class="input-container mb-2 w-full px-4 mb-4"
                    data-cy="company-settings-general-cover-document-filename"
                >
                    <ui-label>
                        {{ $t('company.general.existing_cover_document_filename') }}
                        <a-tooltip placement="right" :title="$t('globals.buttons.delete')">
                            <DeleteOutlined
                                v-if="company.cover_document_filename"
                                class="text-default-red"
                                @click="onCoverDocumentRemove"
                            />
                        </a-tooltip>
                    </ui-label>
                    <ui-input :disabled="true" v-model="coverDocumentTemplateValue" />
                    <p class="text-help">
                        {{ $t('company.general.help.cover_document_filename') }}
                    </p>
                </div>
                <div
                    v-if="is_admin_section && isCiaEnabled && company.company_type.toLowerCase() == 'insurer'"
                    class="input-container mb-2 w-full px-4 mb-4"
                    data-cy="company-settings-general-cover-document-template"
                >
                    <ui-label>{{ $t('company.general.cover_document_template') }}</ui-label>
                    <a-upload
                        accept=".rptdesign"
                        :file-list="cover_document_file_list"
                        @remove="onCoverDocumentTemplateRemove"
                        :before-upload="onBeforeCoverDocumentUpload"
                    >
                        <a-button class="mt-2">
                            <UploadOutlined />
                            {{ $t('company.general.upload') }}
                        </a-button>
                    </a-upload>
                    <validation-errors :errors="validation.errors.certificate_template" v-if="validation.errors" />
                </div>
                <div
                    v-if="!is_create && isCiaEnabled"
                    class="input-container mb-2"
                    :class="{ 'pr-4 lg:w-1/5 md:w-1/4': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                    data-cy="association-company-responsible-user-field"
                >
                    <ui-label>{{ $t('company.general.responsible_user') }}</ui-label>
                    <ui-select
                        v-model="v$.company.responsible_user_id.$model"
                        :options="users_list"
                        :class="{ 'form-error': v$.company.responsible_user_id.$error }"
                    />
                    <p class="text-help">
                        {{ $t('company.general.help.responsible_user') }}
                    </p>
                </div>
                <div
                    v-if="isEpicVaultEnabled"
                    data-cy="association-company-field-settings-is-cover-flat-file-accepted"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-full px-4': form_mode == 'drawer' }"
                >
                    <div>{{ $t('company.general.is_cover_file_upload_type') }}</div>
                    <ui-select
                        v-model="v$.company.cover_file_upload_type.$model"
                        :options="cover_upload_file_types"
                        :class="{ 'form-error': v$.company.cover_file_upload_type.$error }"
                    />
                </div>
            </div>
        </div>
        <div class="form-section" data-cy="section-flags" :class="{ 'mb-12': form_mode == 'drawer' }">
            <div class="form-section-header" :class="{ 'pr-4': form_mode == 'init', 'px-4': form_mode == 'drawer' }">
                <div data-cy="association-company-flags">
                    {{ $t('company.general.title_flags') }}
                </div>
            </div>
            <div class="section-body">
                <div
                    data-cy="association-company-field-is-active"
                    class="input-container"
                    :class="{ 'lg:w-1/6 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_active">
                        {{ $t('company.general.is_active') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-send_claims_summary"
                    class="input-container"
                    :class="{ 'lg:w-1/6 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_send_claims_summary">
                        {{ $t('company.general.send_daily_claims') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-send-covers-summary"
                    class="input-container"
                    :class="{ 'lg:w-1/6 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_send_covers_summary">
                        {{ $t('company.general.send_daily_covers') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-is-no-lock-out"
                    class="input-container"
                    :class="{ 'lg:w-1/4 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_no_lock_out">
                        {{ $t('company.general.is_no_lock_out') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-is-api-access"
                    class="input-container"
                    :class="{ 'lg:w-1/4 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_api_access" :disabled="!is_admin_section">
                        {{ $t('company.general.is_api_access') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-allow-multi-ip-sessions"
                    class="input-container"
                    :class="{ 'lg:w-1/3 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.allow_multi_ip_sessions">
                        {{ $t('company.general.allow_multi_ip_sessions') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-replace-tp"
                    class="input-container"
                    :class="{ 'lg:w-1/3 pr-4': form_mode == 'init', 'lg:w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_replace_tp" :disabled="!is_admin_section">
                        {{ $t('company.general.is_replace_tp') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-is-data-provider"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_data_provider" :disabled="!is_admin_section">
                        {{ $t('company.general.is_data_provider') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-is-enfoce-filename-restriction"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_enforce_filename_restriction" :disabled="!is_admin_section">
                        {{ $t('company.general.is_enforce_filename_restriction') }}
                    </ui-checkbox>
                </div>
                <div
                    v-if="company.is_association_tfa_enabled"
                    data-cy="association-company-field-settings-is-association-tfa-enabled"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_association_tfa_enabled" :disabled="true">
                        {{ $t('company.general.is_association_tfa_enabled') }}
                    </ui-checkbox>
                </div>
                <div
                    v-else
                    data-cy="association-company-field-settings-is-tfa-enabled"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_tfa_enabled">
                        {{ $t('company.general.is_tfa_enabled') }}
                    </ui-checkbox>
                </div>
                <div
                    data-cy="association-company-field-settings-multi-association-link"
                    class="input-container"
                    :class="{ 'pr-4 lg:w-3/5 md:w-2/5': form_mode == 'init', 'w-1/2 px-4': form_mode == 'drawer' }"
                >
                    <ui-checkbox v-model="company.is_multi_association_link" :disabled="!is_admin_section">
                        {{ $t('company.general.is_multi_association_link') }}
                    </ui-checkbox>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'lg:w-1/3 pr-4': form_mode == 'init', 'w-full px-4': form_mode == 'drawer' }"
                    data-cy="association-company-field-settings-linked-associations"
                    v-if="company.is_multi_association_link"
                >
                    <ui-label>{{ $t('company.general.link_association_ids') }}</ui-label>
                    <ui-select-multiple
                        v-model="v$.company.link_association_ids.$model"
                        :options="linked_association_list"
                        :class="{ 'form-error': v$.company.link_association_ids.$error }"
                        :searchable="true"
                        :allowClear="true"
                        v-if="is_admin_section"
                    />
                    <div class="subText" v-else>
                        <p v-if="this.company.linked_associations.length > 0">
                            {{ this.company.linked_associations }}
                        </p>
                        <p v-else class="text-gray-500 text-sm">{{ $t('company.general.no_related_associations') }}</p>
                    </div>
                </div>
                <div
                    class="input-container mb-2"
                    :class="{ 'lg:w-1/3 pr-4': form_mode == 'init', 'w-full px-4': form_mode == 'drawer' }"
                    data-cy="association-company-field-settings-linked-companies"
                    v-if="company.is_multi_association_link"
                >
                    <ui-label>{{ $t('company.general.related_companies') }}</ui-label>
                    <ui-select-multiple
                        v-model="v$.company.link_company_ids.$model"
                        :options="multiCompanyList"
                        :class="{ 'form-error': v$.company.link_company_ids.$error }"
                        :searchable="true"
                        :allowClear="true"
                        v-if="is_admin_section"
                    />
                    <div class="subText" v-else>
                        <p v-if="this.company.linked_companies.length > 0">
                            {{ this.company.linked_companies }}
                        </p>
                        <p v-else class="text-gray-500 text-sm">{{ $t('company.general.no_related_companies') }}</p>
                    </div>
                </div>
            </div>
            <div
                v-if="is_create"
                class="form-section"
                data-cy="section-upload"
                :class="{ 'mb-12 px-4': form_mode == 'drawer' }"
            >
                <ui-label>{{ $t('company.general.import-users') }}</ui-label>
                <a-upload-dragger
                    name="file"
                    data-cy="user-import-drag"
                    @remove="handleUploadRemove"
                    :file-list="file_list"
                    :multiple="true"
                    :before-upload="beforeUploadFile"
                >
                    <p class="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p class="ant-upload-text">{{ $t('user.upload_modal.body') }}</p>
                    <p class="ant-upload-hint">{{ $t('user.upload_modal.hint') }}</p>
                </a-upload-dragger>
            </div>
        </div>

        <div class="drawer-footer" v-if="form_mode == 'drawer'">
            <slot name="actions"></slot>
            <a-button data-cy="drawer-cancel-button" @click="onDrawerClose" class="btn-cancel" :disabled="processing">
                {{ $t('company.general.buttons.cancel') }}
            </a-button>
            <ui-submit-button data-cy="drawer-save-btn" :disabled="processing">
                <span v-if="!processing">{{ $t('company.general.buttons.save') }}</span>
                <span v-else>{{ $t('company.general.buttons.saving') }}</span>
            </ui-submit-button>
        </div>
    </form>
</template>

<script>
import UiCheckbox from '@/components/ui/Checkbox.vue';
import UiInputNumber from '@/components/ui/InputNumber.vue';
import UiInput from '@/components/ui/Input.vue';
import UiLabel from '@/components/ui/Label.vue';
import UiSelect from '@/components/ui/Select.vue';
import UiSelectMultiple from '@/components/ui/SelectMultiple.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import ValidationErrors from '@/components/ui/ValidationErrors.vue';

import {
    PlusSquareOutlined,
    SyncOutlined,
    DeleteOutlined,
    LoadingOutlined,
    PlusOutlined,
    UploadOutlined,
    InboxOutlined,
} from '@ant-design/icons-vue';

import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import formatters from '@/utils/formatters.js';

const phone = (value) =>
    /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/.test(value) || value == '' || value == null;

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components: {
        UiInputNumber,
        UiCheckbox,
        UiInput,
        UiLabel,
        UiSelect,
        UiSelectMultiple,
        UiSubmitButton,
        ValidationErrors,
        PlusSquareOutlined,
        SyncOutlined,
        DeleteOutlined,
        LoadingOutlined,
        PlusOutlined,
        UploadOutlined,
        InboxOutlined,
    },
    data() {
        return {
            salutations: [],
            company_types: [],
            loading: false,
            image_file: {},
            image_updated: false,
            formatters,
            association_list: {},
            company_list: {},
            linked_association_list: [],
            linked_company_list: [],
            association_id: null,
            file_list: [],
            cover_document_file_list: [],
            cover_document_file: null,
            cover_document_file_updated: false,
            file_limit: -3,
            is_ready: false,
            users_list: [],
            claims_upload_file_types: [
                {
                    text: this.$t('company.general.file_upload_types.flat_file_default'),
                    value: 'flat_file',
                },
                {
                    text: this.$t('company.general.file_upload_types.flat_file_minimum'),
                    value: 'flat_file_minimum',
                },
            ],
            cover_upload_file_types: [
                {
                    text: this.$t('company.general.file_upload_types.flat_file_default'),
                    value: 'flat_file',
                },
                {
                    text: this.$t('company.general.file_upload_types.json'),
                    value: 'json',
                },
            ],
        };
    },
    validations: {
        company: {
            name: { required },
            company_code: { required },
            company_type: { required },
            contact_last_name: {},
            contact_first_name: {},
            mailing_address: {},
            telephone_number: { phone },
            email_address: {
                emailValidation(emails) {
                    const email_reg =
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let is_valid = true;

                    _.forEach(emails, function (test_email) {
                        if (!email_reg.test(String(test_email).toLowerCase())) {
                            is_valid = false;
                        }
                    });

                    return is_valid;
                },
            },
            cover_document_filename: {},
            responsible_user_id: {},
            salutation: {},
            ip_range: {},
            is_active: {},
            is_no_lock_out: {},
            is_api_access: {},
            allow_multi_ip_sessions: {},
            is_replace_tp: {},
            is_hide_claim_description: {},
            claim_last_imported_at: {},
            cover_last_imported_at: {},
            deactivation_date: {},
            is_multi_association_link: {},
            is_data_provider: {},
            is_enforce_filename_restriction: {},
            is_enforce_column_count_restriction: {},
            update_upload_date_on_new_claims: {},
            is_module_claimsvault_enabled: {},
            is_module_covervault_enabled: {},
            enable_advanced_claims_analytics: {},
            enable_advanced_cover_analytics: {},
            email_rejected_records_on_upload_claims: {},
            email_rejected_records_on_upload_covers: {},
            claim_file_upload_type: {},
            cover_file_upload_type: {},
            link_association_ids: {},
            link_company_ids: {},
            authorized_intermediary_id: {},
            is_tfa_enabled: {},
            send_import_claim_email: {},
            send_import_cover_email: {},
            allow_full_association_cover_search: {},
            max_immediate_cover_processing_limit: {},
            national_id: {},
            is_send_claims_summary: {},
            is_send_covers_summary: {},
        },
    },
    props: {
        company: Object,
        processing: Boolean,
        is_create: Boolean,
        is_admin_section: Boolean,
        validation: Object,
        form_mode: {
            type: String,
            default: 'init',
        },
    },
    computed: {
        isEpicVaultEnabled() {
            return this.$store.getters['system/isEpicvaultEnabled'];
        },
        isCiaEnabled() {
            return this.$store.state.user.modules.cia;
        },
        multiCompanyList() {
            let list = [];

            if (this.company.link_association_ids.length == 0) {
                this.company.link_company_ids = [];
            } else {
                let accepted_company_ids = [];
                let used_association_ids = [];

                if (this.is_ready) {
                    // validate selected company ids first
                    this.company.link_company_ids.forEach((company_id) => {
                        this.linked_company_list.forEach((record) => {
                            let var_split = record.value.split('_');

                            if (
                                var_split[1] == company_id &&
                                _.indexOf(this.company.link_association_ids, var_split[0]) >= 0
                            ) {
                                accepted_company_ids.push(company_id);
                                used_association_ids.push(var_split[0]);
                            }
                        });
                    });

                    this.company.link_company_ids = accepted_company_ids;
                }

                // formulate the available company list next
                this.linked_company_list.forEach((record) => {
                    let var_split = record.value.split('_');
                    let is_disabled = false;
                    let should_be_added = false;

                    this.company.link_company_ids.forEach((company_id) => {
                        if (var_split[1] == company_id) {
                            should_be_added = true;
                        }
                    });

                    this.company.link_association_ids.forEach((association_id) => {
                        if (var_split[0] == association_id) {
                            should_be_added = true;
                        }
                    });

                    if (should_be_added) {
                        list.push({
                            text: record.text,
                            value: var_split[1],
                            disabled: is_disabled,
                        });
                    }
                });
            }
            return list;
        },
        coverDocumentTemplateValue() {
            return this.company.cover_document_filename !== '' &&
                this.company.cover_document_filename !== null &&
                this.company.cover_document_filename !== undefined
                ? this.company.cover_document_filename
                : this.$t('company.general.no_cover_document_template');
        },
    },
    mounted() {
        this.fetch();
    },
    methods: {
        captilalizeText(text) {
            if (text !== '' && text !== undefined && text !== null) {
                return text.replace(/^\w/, (c) => c.toUpperCase());
            }

            return '';
        },
        fetch() {
            this.is_ready = false;
            let urls = [
                this.$http.get('/api/listmanager/category/salutation'),
                this.$http.get('/api/listmanager/category/company_type'),
                this.$http.get('/api/companies/multi-association-list'),
            ];

            if (this.is_admin_section) {
                urls.push(this.$http.get('/api/admin/list-associations'));
            }

            if (this.company.id !== undefined && this.company.id.length > 0) {
                urls.push(this.$http.get('/api/companies/' + this.company.id + '/user-list'));
            }

            this.$http.all(urls).then(
                this.$http.spread(
                    (salutations, company_types, association_company_list, association_list, user_list) => {
                        let api_user_list = [];

                        this.salutations = [];
                        this.company_types = [];

                        salutations.data.data.forEach((record) => {
                            this.salutations.push({
                                text: record.item,
                                value: record.value,
                            });
                        });

                        company_types.data.data.forEach((record) => {
                            if (record.flag_a) {
                                this.company_types.push({
                                    text: record.item,
                                    value: record.value,
                                });
                            }
                        });

                        if (this.is_admin_section || this.linked_association_list.length < 1) {
                            association_company_list.data.association_list.forEach((record) => {
                                this.linked_association_list.push({
                                    text: record.name,
                                    value: record.id,
                                });

                                record.companies.forEach((company) => {
                                    this.linked_company_list.push({
                                        text: company.name,
                                        value: record.id + '_' + company.id,
                                    });
                                });
                            });
                        }

                        if (this.is_admin_section) {
                            this.association_list = association_list.data.data;
                        }

                        if (this.company.id !== undefined && this.company.id.length > 0) {
                            if (this.is_admin_section) {
                                api_user_list = user_list.data.data;
                            } else {
                                api_user_list = association_list.data.data;
                            }

                            if (api_user_list !== undefined) {
                                api_user_list.forEach((record) => {
                                    this.users_list.push({
                                        text: record.name,
                                        value: record.id,
                                    });
                                });
                            }
                        }

                        this.is_ready = true;
                    },
                ),
            );
        },
        onFormChange() {
            this.$emit('is-form-dirty', true);
        },
        isFormDirty() {
            this.$emit('is-form-dirty', this.v$.$anyDirty);
        },
        handleRemove(event) {
            if (this.company.insurer_logo != null && this.company.insurer_logo != '') {
                this.image_updated = true;
                this.company.insurer_logo = null;
            }
        },
        beforeUpload(file) {
            this.loading = true;

            this.image_file = file;
            this.image_updated = true;
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

            if (!isJpgOrPng) {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'Logo', values: 'JPEG|PNG' }),
                });
            }

            const isLtKB = file.size / 1024 / 1024 < 2;
            if (!isLtKB) {
                this.$notification.error({
                    message: this.$t('validation.lt.file', { attribute: 'Logo', value: 2048 }),
                });
            }

            if (isJpgOrPng && isLtKB) {
                this.company.insurer_logo = URL.createObjectURL(file);
            }

            this.loading = false;

            return false;
        },
        handleFilterChange(value) {
            if (value == undefined) {
                this.company.association_id = null;
                this.company.is_association_tfa_enabled = false;
            } else {
                this.company.association_id = this.association_list[value].id;
                this.company.is_association_tfa_enabled =
                    this.association_list[value].is_tfa_enabled == 1 ? true : false;
            }
        },
        filterOption(input, option) {
            return option.children()[0].children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        updateDate() {
            this.$emit('updateDate', this.company.id);
        },
        updateDeactivationDate() {
            this.$emit('updateDeactivationDate', this.company.id);
        },
        autofillEmail() {
            let fill_list = [];

            this.$http
                .get('/api/companies/' + this.company.id + '/get-data-sender-emails')
                .then((response) => {
                    response.data.data.forEach((record) => {
                        fill_list.push(record.email);
                    });
                    this.$emit('autofillEmail', fill_list);
                })
                .catch((error) => {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVAL03' }),
                    });
                });
        },
        async handleSubmit() {
            if (this.is_create && this.company.association_id == null) {
                return false;
            }

            if (!(await this.v$.$validate())) return false;

            let company = {
                ...this.company,
                email_address: _.join(this.company.email_address, ','),
            };

            const fm_data = new FormData();

            Object.keys(company).forEach(function (key_value, index) {
                if (company[key_value] === true) {
                    company[key_value] = 1;
                } else if (company[key_value] === false && company[key_value] !== '') {
                    company[key_value] = 0;
                }
            });

            for (var key in company) {
                if (
                    key != 'insurer_logo' &&
                    key != 'cover_document_file' &&
                    key != 'cover_document_filename' &&
                    key != 'user_count' &&
                    company[key] != null
                ) {
                    fm_data.append(key, company[key]);
                }
            }

            if (this.is_create) {
                const { file_list } = this;

                file_list.forEach((file) => {
                    fm_data.append('files[]', file);
                });
            }

            if (this.image_updated) {
                if (this.company.insurer_logo != null && this.company.insurer_logo != '') {
                    fm_data.set('insurer_logo', this.image_file);
                } else {
                    fm_data.set('remove_logo', true);
                }
            }

            if (this.cover_document_file_updated) {
                if (this.cover_document_file != null && this.cover_document_file != '') {
                    fm_data.append('cover_document_file', this.cover_document_file);
                } else {
                    fm_data.set('removed_cover_document_template', true);
                }
            }

            this.image_updated = false;
            this.v$.$reset();

            this.$emit('formSubmit', fm_data);
        },
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
        handleUploadRemove(file) {
            const index = this.file_list.indexOf(file);
            const new_file_list = this.file_list.slice();
            new_file_list.splice(index, 1);
            this.file_list = new_file_list;
        },
        beforeUploadFile(file) {
            const isCSV = file.type === 'text/csv';
            const isXSL = file.type === 'application/vnd.ms-excel';
            const isXSLX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (isCSV || isXSL || isXSLX) {
                if (this.file_list.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.file_list = [...this.file_list, file].slice(this.file_limit);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'CSV, XSL or XSLX' }),
                });
            }
            return false;
        },
        onCoverDocumentTemplateRemove(file) {
            this.cover_document_file_list = [];
            this.cover_document_file = null;
            this.cover_document_file_updated = false;
        },
        onBeforeCoverDocumentUpload(file) {
            if (this.isTemplateValid(file)) {
                this.cover_document_file_updated = true;
                this.cover_document_file_list = [file];
                this.cover_document_file = file;
            }

            return false;
        },
        isTemplateValid(file) {
            let is_file_valid = true;

            // cannot check rptdesign file type but can check file size
            let mb = 1000000; // 1MB
            let extension = 'unknown';
            let file_split = file.name.split('.');

            if (file_split.length > 1) {
                extension = file_split[file_split.length - 1];
            }

            if (extension !== 'rptdesign') {
                is_file_valid = false;

                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: 'rptdesign' }),
                });
            }

            if (file.size >= mb) {
                is_file_valid = false;

                this.$notification.error({
                    message: this.$t('validation.lt.file', { attribute: 'File', value: 1024 }),
                });
            }

            return is_file_valid;
        },
        onCoverDocumentRemove(event) {
            if (this.company.cover_document_filename !== null && this.company.cover_document_filename !== '') {
                this.cover_document_file_updated = true;
                this.company.cover_document_filename = null;
            }
        },
        onClaimsVaultModuleChange(event) {
            const value = event.target.checked;

            if (!value && !this.is_create && this.form_mode == 'drawer') {
                let vm = this;

                this.$confirm({
                    title: this.$t('company.general.disable_claimsvault_module_modal.title'),
                    content: this.$t('company.general.disable_claimsvault_module_modal.content'),
                    onOk() {
                        vm.company.is_module_claimsvault_enabled = value;
                    },
                    onCancel() {
                        vm.company.is_module_claimsvault_enabled = !value;
                    },
                });
            } else {
                this.company.is_module_claimsvault_enabled = value;
            }
        },
        onCoverVaultModuleChange(event) {
            const value = event.target.checked;

            if (!value && !this.is_create && this.form_mode == 'drawer') {
                let vm = this;

                this.$confirm({
                    title: this.$t('company.general.disable_covervault_module_modal.title'),
                    content: this.$t('company.general.disable_covervault_module_modal.content'),
                    onOk() {
                        vm.company.is_module_covervault_enabled = value;
                    },
                    onCancel() {
                        vm.company.is_module_covervault_enabled = !value;
                    },
                });
            } else {
                this.company.is_module_covervault_enabled = value;
            }
        },
    },
};
</script>
